import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import taskService from '../../services/taskService';
import './TaskList.css';
import IssueStore from '../Issues/IssueStore';
import CommonModal from '../../services/CommonModal';
import TaskStore from './TaskStore';
import milestoneService from '../../services/milestoneService';
import projectService from '../../services/projectService';
import Select from "react-select";
import { FaChevronDown, FaChevronUp, FaFileExcel } from "react-icons/fa";
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'react-toastify';
import { FiX, } from 'react-icons/fi';
import { Doughnut } from 'react-chartjs-2';
import { FaRegCommentDots } from 'react-icons/fa6';
import { customDateFormatShort } from '../../config/utils';


const externalTooltipHandler = (context) => {
  const { chart, tooltip } = context;

  let tooltipEl = chart.canvas.parentNode.querySelector(".chart-tooltip");

  if (!tooltipEl) {
    tooltipEl = document.createElement("div");
    tooltipEl.className = "chart-tooltip";

    tooltipEl.innerHTML = `
      <div class="chart-tooltip-content"></div>
    `;

    chart.canvas.parentNode.appendChild(tooltipEl);
  }

  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0;
    return;
  }

  const content = tooltipEl.querySelector(".chart-tooltip-content");

  if (tooltip.body) {
    const title = tooltip.title || [];
    const body = tooltip.body.map((bodyItem) => bodyItem.lines);

    content.innerHTML = `
      ${title.length
        ? `<div class="tooltip-title">${title.join("<br>")}</div>`
        : ""
      }

      ${body
        .map(
          (line) => `
            <div class="tooltip-value">
              ${line.join("<br>")}
            </div>
          `
        )
        .join("")}
    `;
  }

  const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;

  tooltipEl.style.opacity = 1;
  tooltipEl.style.left = `${positionX + tooltip.caretX}px`;
  tooltipEl.style.top = `${positionY + tooltip.caretY}px`;
};


const taskStatusData = {
  labels: [
    "To Do",
    "In Progress",
    "Completed",
    "Blocked",
    "Review",
    "Bug"
  ],
  datasets: [
    {
      data: [15, 25, 35, 10, 15],
      backgroundColor: [
        "#3B82F6", // Blue
        "#F59E0B", // Orange
        "#10B981", // Green
        "#EF4444", // Red
        "#8B5CF6", // Purple
      ],
      borderColor: "#ffffff",
      borderWidth: 2,
      hoverOffset: 8,
    },
  ],
};


const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  cutout: "70%",
  plugins: {
    legend: {
      position: "bottom",
    },
    tooltip: {
      enabled: true,
    },
  },
};


const TaskList = () => {
  const [tasks, setTasks] = useState([]);
  const [resources, setResources] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const { setSelectedCopyTask, clearSelectedCopyTask } = TaskStore();
  const [projects, setProjects] = useState([]);
  const [milestones, setMilestones] = useState([]);
  const [users, setUsers] = useState([]);
  const [pagination, setPagination] = useState({});
  const { selectedIssue, setSelectedIssue, clearSelectedIssue } = IssueStore();
  const [showStatus, setShowStatus] = useState(false);
  const [showAssignees, setShowAssignees] = useState(false);
  const { user } = useAuth();
  const dropdownRef = useRef(null);
  const statusDropdownRef = useRef(null);
  const [hoveredTaskId, setHoveredTaskId] = useState(null);
  const [taskStatuses, setTaskStatuses] = useState({});

  const [selectedTasks, setSelectedTasks] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [moveAction, setMoveAction] = useState("");
  const [moveStatus, setMoveStatus] = useState("");
  const [milestoneId, setMilestoneId] = useState("");

  useEffect(() => {
    if (selectedTasks.length > 0) {
      setFormData(
        selectedTasks.map((task) => ({
          task_id: task.id,
          task_status: task.task_status || task.status || "",
          completed_hours: task.actual_hours || "",
          estimated_hours: task.estimated_hours || "",
        }))
      );
      console.log("resources", resources)
    } else {
      setFormData([]);
    }
  }, [selectedTasks]);
  const [formData, setFormData] = useState([]);

  const formatTime = (date) => {
    return new Date(date).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const handleChange = (e) => {
    setMilestoneId(e.target.value);
  };


  const handleTaskStateChange = async (taskId, status) => {
    // Update displayed value immediately
    setTaskStatuses((prev) => ({
      ...prev,
      [taskId]: status,
    }));

    // try {
    //   await axios.put(`/api/tasks/${taskId}/status`, {
    //     status,
    //   });
    // } catch (error) {
    //   console.error("Status update failed:", error);
    // }
  };


  const handleSelectedMoveChange = (e) => {
    const action = e.target.value;

    setMoveAction(action);

    // Reset only the header values
    setFormData((prev) =>
      Array.isArray(prev)
        ? prev.map((item) => ({
          ...item,
          task_status: "",
          move_status: "",
        }))
        : []
    );

    // Clear status for selected tasks
    setSelectedTasks((prev) =>
      Array.isArray(prev)
        ? prev.map((task) => ({
          ...task,
          task_status: "",
        }))
        : []
    );

    setMoveStatus("");
  };


  const handleHeaderStatusChange = (e) => {
    const status = e.target.value;

    setMoveStatus(status);

    // Update header status in formData
    setFormData((prev) =>
      Array.isArray(prev)
        ? prev.map((item) => ({
          ...item,
          task_status: status,
          move_status: status,
        }))
        : []
    );

    // Update status for every selected task
    setSelectedTasks((prev) =>
      Array.isArray(prev)
        ? prev.map((task) => ({
          ...task,
          task_status: status,
        }))
        : []
    );
  };



  const handleInputChange = (index, field, value) => {
    setSelectedTasks((prev) =>
      prev.map((task, i) =>
        i === index
          ? { ...task, [field]: value }
          : task
      )
    );
  };

  const handleTaskStatusChange = (index, status) => {
    // Update selected task
    setSelectedTasks((prev) =>
      Array.isArray(prev)
        ? prev.map((task, i) =>
          i === index
            ? {
              ...task,
              task_status: status,
            }
            : task
        )
        : []
    );

    // Update form data
    setFormData((prev) =>
      Array.isArray(prev)
        ? prev.map((item, i) =>
          i === index
            ? {
              ...item,
              task_status: status,
              move_status: status,
            }
            : item
        )
        : []
    );
  };


  const handleTaskInputChange = (index, field, value) => {
    setFormData((prev) =>
      Array.isArray(prev)
        ? prev.map((item, i) =>
          i === index
            ? {
              ...item,
              [field]: value,
            }
            : item
        )
        : []
    );
  };




  const handleSubmitSelectedTasks = async () => {
    const payload = {
      action: moveAction,
      project_id: filters.project_id,
      tasks: selectedTasks,
    };

    if (moveAction === "move_to_status") {
      payload.status = moveStatus;
    }

    if (moveAction === "move_to_sprint") {
      payload.milestone_id = milestoneId;
    }

    console.log("PAYLOAD:", payload);

    // return false;

    try {
      await taskService.submitBulkTasks(payload);

      toast.success("Submitted successfully");

      setShowModal(false);
      setSelectedTasks([]);
      setFormData([]);
      setMoveAction("");
      setMoveStatus("");
      setMilestoneId("");

      fetchTasks();
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to submit"
      );
    }
  };

  const handleSelectTask = (task, checked) => {
    setSelectedTasks((prev) => {
      let updated;

      if (checked) {
        updated = prev.some((item) => item.id === task.id)
          ? prev
          : [...prev, task];
      } else {
        updated = prev.filter((item) => item.id !== task.id);
      }

      return updated;
    });
  };

  const handleSelectAll = (checked) => {
    const updated = checked ? [...tasks] : [];

    setSelectedTasks(updated);
  };

  // const handleSelectAll = (checked) => {
  //   if (checked) {
  //     setSelectedTasks(tasks);
  //   } else {
  //     setSelectedTasks([]);
  //   }
  // };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setShowAssignees(false);
      }

      if (
        statusDropdownRef.current &&
        !statusDropdownRef.current.contains(event.target)
      ) {
        setShowStatus(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const statusOptions = [
    { value: "All", label: "All status" },
    { value: "To Do", label: "To Do" },
    { value: "In Progress", label: "In Progress" },
    { value: "In Review", label: "In Review" },
    { value: "Done", label: "Done" },
    { value: "Blocked", label: "Blocked" },
    { value: "Bug", label: "Bug" },
  ];

  const setCopySelectedTask = TaskStore(
    (state) => state.setCopySelectedTask
  );

  const [isProjectOpen, setIsProjectOpen] = useState(false);
  const [isMilestoneOpen, setIsMilestoneOpen] = useState(false);
  const [isPriorityOpen, setIsPriorityOpen] = useState(false);
  const [isStateOpen, setIsStateOpen] = useState(false);
  const isAdmin = user?.role?.name === "Admin";


  const [filters, setFilters] = useState({
    status: ['To Do'],
    assigned_to: isAdmin ? [] : [`${user.id}`],
    priority: '',
    state: '',
    search: '',
    page: 1,
    limit: 20
  });

  const confirmDelete = () => {
    console.log("uuuu")
    handleDelete(selectedTask.id);
    setShowDeleteModal(false);
  };

  const fetchMilestones = async () => {
    try {
      const data = await milestoneService.getAllMilestones();
      setMilestones(data.data || []);
    } catch (err) {
      console.error('Failed to fetch milestones:', err);
    }
  };

  const handleStateChange = async (task, newState) => {
  try {
    // Update UI immediately
    setTaskStatuses((prev) => ({
      ...prev,
      [task.id]: newState,
    }));
    const payload = { state: newState };
    const data = await taskService.changeState(task.id, payload);
  } catch (error) {
    console.error("Failed to update task state:", error);

  }
};

  const fetchProjects = async () => {
    try {
      const data = await projectService.getAllProjects();
      setProjects(data.projects || []);
    } catch (err) {
      console.error('Failed to fetch projects:', err);
    }
  };
  const loadUsers = async () => {
    try {
      const data = await taskService.getAll();
      console.log("users", data)
      setUsers(data.users || []);
    } catch (error) {
      console.error('Error loading users:', error);
    }
  };
  useEffect(() => {
    fetchTasks();
    fetchProjects();
    // fetchMilestones();
    loadUsers();
  }, [filters]);
  const navigate = useNavigate();

  const fetchTasks = async () => {
    try {
      setLoading(true);
      const data = await taskService.getAllTasks(filters);
      setTasks(data.tasks || []);
      setResources(data.summary || []);
      setPagination(data.pagination || {});
      console.log("resources", data)
      setError(null);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to fetch tasks');
      setTasks([]); // Set empty array on error
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await taskService.deleteTask(id);
      fetchTasks();
    } catch (err) {
      alert(err.response?.data?.error || 'Failed to delete task');
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value, page: 1 }));
  };
  const realStatuses = statusOptions
    .filter((s) => s.value !== "All")
    .map((s) => s.value);

  const  handleStatusChange = (status) => {
    setFilters((prev) => {
      if (status === "All") {
        const isAllSelected = realStatuses.every((s) => prev.status.includes(s));
        return { ...prev, status: isAllSelected ? [] : realStatuses };
      }

      const updated = prev.status.includes(status)
        ? prev.status.filter((s) => s !== status)
        : [...prev.status, status];

      return { ...prev, status: updated };
    });
    setShowStatus(false);
  };

  const handleAssigneeChange = (userId) => {
    setFilters((prev) => ({
      ...prev,
      assigned_to: prev.assigned_to.includes(userId)
        ? prev.assigned_to.filter((id) => id !== userId)
        : [...prev.assigned_to, userId],
    }));

    setShowAssignees(false); // Remove this line if you don't want it to close after each selection.
  };

  const handleAllAssignees = () => {
    if (filters.assigned_to.length === users.length) {
      // Uncheck all
      setFilters((prev) => ({
        ...prev,
        assigned_to: [],
      }));
    } else {
      // Select all users
      setFilters((prev) => ({
        ...prev,
        assigned_to: users.map((user) => user.id),
      }));
    }
  };


  const getStatusBadge = (status) => {
    const statusColors = {
      'To Do': 'badge-secondary',
      'In Progress': 'badge-primary',
      'In Review': 'badge-warning',
      'Done': 'badge-success',
      'Blocked': 'badge-danger',
      'Bug': 'Bug',


    };
    return statusColors[status] || 'badge-secondary';
  };

  const getPriorityBadge = (priority) => {
    const priorityColors = {
      'Low': 'badge-info',
      'Medium': 'badge-warning',
      'High': 'badge-danger',
      'Critical': 'badge-danger-dark'
    };
    return priorityColors[priority] || 'badge-secondary';
  };

  if (loading && tasks.length === 0) {
    return <div className="loading">Loading tasks...</div>;
  }

  const handleTaskClick = (id, isEdit) => {
    clearSelectedIssue()
    navigate(`/app/tasks/${id}`);
    console.log("iddd", id, isEdit)
  };


  const handleTaskEdit = (id) => {
    clearSelectedIssue()
    navigate(`/app/tasks/${id}/edit`);
    console.log("iddd", id)
  };

  const handleTaskCopy = (task) => {
    setCopySelectedTask(task);
    console.log("Copied task:", task);
    navigate("/app/tasks/new");
  };

  const downloadFileFromUrl = (fileUrl, fileName) => {
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const downloadTaskAsJson = (task) => {
    const dataStr = JSON.stringify(task, null, 2);
    const blob = new Blob([dataStr], { type: 'application/json' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `task-${task.task_code || task.id}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleTaskDownload = async (task) => {
    try {
      const attachments = task.attachments || [];

      if (attachments.length === 0) {
        toast.error('No data found');
        return;
      }

      for (const attachment of attachments) {
        const fileName = attachment.file_name || `attachment-${attachment.id}`;
        try {
          downloadFileFromUrl(attachment.attachment_url, fileName);
        } catch (fileErr) {
          console.error(`Failed to download attachment ${fileName}:`, fileErr);
          alert(`Failed to download attachment: ${fileName}`);
        }
      }
    } catch (err) {
      console.error('Failed to download task:', err);
      alert('Failed to download task');
    }
  };


  const goToView = (task) => {
    setCopySelectedTask(task);
    console.log("Copied task:", task);
    navigate("/app/tasks/:id");
  };

  const handleTaskCreate = () => {
    setCopySelectedTask(null);
    navigate(`/app/tasks/new`);
  };;

  const selectedUsers = users.filter((user) =>
    filters.assigned_to.includes(user.id)
  );

  const handleMoveChange = (e) => {
    const value = e.target.value;

    if (value === "move_out") {
      if (!filters.project_id) {
        toast.error("Please select a project");
        e.target.value = "";
        return;
      }

      if (selectedTasks.length === 0) {
        toast.error("Please select at least one task");
        e.target.value = "";
        return;
      }

      setShowModal(true);
      e.target.value = "";
    }
  };


  const handleProjectChange = async (e) => {
    const value = e.target.value;


    setSelectedTasks([]);

    // Update filter
    setFilters((prev) => ({
      ...prev,
      project_id: value,
    }));

    try {
      console.log("Calling API for project:", value);

      const data = await projectService.getProjectMilestones(value);
      setMilestones(data?.milestones || []);

      console.log("Milestones:", data);
    } catch (error) {
      setMilestones([]);
      toast.error("Milestones not found");
      console.error("API Error:", error);
    }
  };



  const hasUnassigned = filters.assigned_to.includes("unassigned");

  const getAssigneeDisplay = () => {
    // Nothing selected
    if (filters.assigned_to.length === 0) {
      return "All";
    }

    // All users selected (without Unassigned)
    if (
      !hasUnassigned &&
      users.length > 0 &&
      selectedUsers.length === users.length
    ) {
      return "All Assignees";
    }

    const labels = [];

    if (hasUnassigned) {
      labels.push("Unassigned");
    }

    selectedUsers.forEach((user) => {
      labels.push(`${user.first_name} ${user.last_name}`);
    });

    if (labels.length === 1) {
      return labels[0];
    }

    if (labels.length === 2) {
      return `${labels[0]}, ${labels[1]}`;
    }

    return `${labels[0]}, ${labels[1]} +${labels.length - 2}`;
  }

  const handleDownloadTaskList = () => {
    if (!tasks || tasks.length === 0) {
      toast.error('No tasks to download');
      return;
    }

    const headers = [
      'Task Code', 'Title', 'Type', 'Milestone', 'Assignee',
      'Actual Hours', 'Estimated Hours', 'Status', 'Priority',
      'Due Date', 'Created By', 'Created At'
    ];

    const escapeCsv = (value) => {
      if (value === null || value === undefined) return '';
      const str = String(value);
      if (str.includes(',') || str.includes('"') || str.includes('\n')) {
        return `"${str.replace(/"/g, '""')}"`;
      }
      return str;
    };

    const rows = tasks.map((task) => [
      task.task_code,
      task.title,
      task.task_type || 'Task',
      task.milestone ? (task.milestone.name || task.milestone_id) : '',
      task.assignee ? `${task.assignee.first_name} ${task.assignee.last_name}` : 'Unassigned',
      task.actual_hours ?? 0,
      task.estimated_hours ?? 0,
      task.status,
      task.priority,
      task.due_date ? customDateFormatShort(task.due_date) : '',
      task.reporter ? `${task.reporter.first_name} ${task.reporter.last_name}` : '',
      task.createdAt ? formatTime(task.createdAt) : ''
    ]);

    const csvContent = [headers, ...rows]
      .map((row) => row.map(escapeCsv).join(','))
      .join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `task-list-${new Date().toISOString().slice(0, 10)}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    toast.success('Task list downloaded');
  };

  return (
    <>
      <div className="task-list-header">
        <h1>Tasks</h1>

        <div className='flex gap-4'>
          <div className="relative">
            <select
              onChange={handleMoveChange}
              onFocus={() => setIsProjectOpen(true)}
              onBlur={() => setIsProjectOpen(false)}
              className="w-full appearance-none rounded-lg border border-gray-300 bg-white px-4 py-2.5 pr-10 text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200"
            >
              <option value="">Select Action</option>
              <option value="move_out">Move</option>
            </select>

            <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
              {isProjectOpen ? <FaChevronUp /> : <FaChevronDown />}
            </div>
          </div>

          <div>
            <button onClick={() => handleTaskCreate()} className="btn btn-primary">
              <i className="fas fa-plus"></i> Create Task
            </button>
          </div>

          <div>
            <button
              onClick={handleDownloadTaskList}
              className="px-4 py-3 bg-white border border-green-600 text-green-600 rounded-lg flex items-center gap-2"
              title="Download task list"
            >
              <FaFileExcel />
            </button>
          </div>

        </div>

      </div>


      <div className='flex w-full gap-2'>
        <div className='w-4/5'>
          <div className="task-list-container ">


            {error && <div className="alert alert-danger">{error}</div>}
            <CommonModal
              isOpen={showDeleteModal}
              title="Delete Task"
              message="Are you sure you want to delete this task?"
              onClose={() => {
                setShowDeleteModal(false);
                setSelectedTask(null);
              }}
              onConfirm={confirmDelete}
              type="error"
              confirmText="Delete"
              cancelText="Cancel"
            />

            <div className="grid grid-cols-1 gap-4 mb-6 md:grid-cols-2 xl:grid-cols-6 ">

              {/* Project */}
              <div className="relative w-full">
                <select
                  name="project_id"
                  value={filters.project_id}
                  onChange={handleProjectChange}
                  onFocus={() => setIsProjectOpen(true)}
                  onBlur={() => setIsProjectOpen(false)}
                  className="w-full appearance-none rounded-lg border border-gray-300 bg-white px-4 py-2.5 pr-10 text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200"
                >
                  <option value="">All Projects</option>
                  {projects.map((project) => (
                    <option key={project.id} value={project.id}>
                      {project.name}
                    </option>
                  ))}
                </select>

                <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
                  {isProjectOpen ? <FaChevronUp /> : <FaChevronDown />}
                </div>
              </div>

              {/* Milestone */}
              <div className="relative w-full">
                <select
                  name="milestone_id"
                  value={filters.milestone_id}
                  onChange={handleFilterChange}
                  onFocus={() => setIsMilestoneOpen(true)}
                  onBlur={() => setIsMilestoneOpen(false)}
                  className="w-full appearance-none rounded-lg border border-gray-300 bg-white px-4 py-2.5 pr-10 text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200"
                >
                  <option value="">All Milestones</option>
                  {milestones.map((milestone) => (
                    <option key={milestone.id} value={milestone.id}>
                      {milestone.name} {milestone.project && ''} {customDateFormatShort(milestone.due_date)} to{' '}
                      {customDateFormatShort(milestone.completion_date)}{' '}
                      {milestone.status === 'In Progress' && '- Current'}
                    </option>
                  ))}
                </select>

                <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
                  {isMilestoneOpen ? <FaChevronUp /> : <FaChevronDown />}
                </div>
              </div>

              {/* Assignees */}
              {/* <div
                className="relative"
                ref={dropdownRef}
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setShowAssignees((prev) => !prev);
                  }}
                  className="flex w-full items-center justify-between rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm hover:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-200"
                >
                  <span className="truncate">
                    {filters.assigned_to.includes("unassigned")
                      ? "Unassigned"
                      : filters.assigned_to.length === users.length
                        ? "All Assignees"
                        : filters.assigned_to.length === 0
                          ? "All"
                          : `${selectedUsers[0]?.first_name || ""} ${selectedUsers[0]?.last_name || ""
                          }${selectedUsers.length > 1
                            ? ` +${selectedUsers.length - 1}`
                            : ""
                          }`}
                  </span>

                  {showAssignees ? <FaChevronUp /> : <FaChevronDown />}
                </button>

                {showAssignees && (
                  <div
                    className="absolute left-0 right-0 z-50 mt-2 max-h-64 overflow-y-auto rounded-lg border border-gray-200 bg-white shadow-lg"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <label className="flex cursor-pointer items-center gap-3 px-4 py-2 hover:bg-gray-100">
                      <input
                        type="checkbox"
                        checked={
                          users.length > 0 &&
                          filters.assigned_to.length === users.length
                        }
                        onClick={(e) => e.stopPropagation()}
                        onChange={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleAllAssignees();
                        }}
                      />
                      <span>All Assignees</span>
                    </label>

                    <label className="flex cursor-pointer items-center gap-3 px-4 py-2 hover:bg-gray-100">
                      <input
                        type="checkbox"
                        checked={filters.assigned_to.includes("unassigned")}
                        onClick={(e) => e.stopPropagation()}
                        onChange={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleAssigneeChange("unassigned");
                        }}
                      />
                      <span>Unassigned</span>
                    </label>

                    <hr />

                    {users.map((user) => (
                      <label
                        key={user.id}
                        className="flex cursor-pointer items-center gap-3 px-4 py-2 hover:bg-gray-100"
                      >
                        <input
                          type="checkbox"
                          checked={filters.assigned_to.includes(user.id)}
                          onClick={(e) => e.stopPropagation()}
                          onChange={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleAssigneeChange(user.id);
                          }}
                        />
                        <span>
                          {user.first_name} {user.last_name}
                        </span>
                      </label>
                    ))}
                  </div>
                )}
              </div> */}

              {/* Status */}
              <div className="relative" ref={statusDropdownRef}>
                <button
                  type="button"
                  onClick={() => setShowStatus((prev) => !prev)}
                  className="flex w-full items-center justify-between rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm hover:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-200"
                >
                  <span className="truncate">
                    {filters.status.length
                      ? filters.status.join(", ")
                      : "All Status"}
                  </span>

                  {showStatus ? <FaChevronUp /> : <FaChevronDown />}
                </button>

                {showStatus && (
                  <div className="absolute left-0 right-0 z-50 mt-2 max-h-64 overflow-y-auto rounded-lg border border-gray-200 bg-white shadow-lg">
                    {statusOptions.map((status) => (
                      <label key={status.value} className="flex cursor-pointer items-center gap-3 px-4 py-2 hover:bg-gray-100">
                        <input
                          type="checkbox"
                          checked={
                            status.value === "All"
                              ? realStatuses.every((s) => filters.status.includes(s))
                              : filters.status.includes(status.value)
                          }
                          onChange={() => handleStatusChange(status.value)}
                        />
                        {status.label}
                      </label>
                    ))}
                  </div>
                )}
              </div>

              {/* Priority */}
              <div className="relative w-full">
                <select
                  name="priority"
                  value={filters.priority}
                  onChange={handleFilterChange}
                  className="w-full appearance-none rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200"
                >
                  <option value="">All Priority</option>
                  <option value="Low">Low</option>
                  <option value="Medium">Medium</option>
                  <option value="High">High</option>
                  <option value="Critical">Critical</option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
                  {isPriorityOpen ? <FaChevronUp /> : <FaChevronDown />}
                </div>
              </div>
               <div className="relative w-full">
                <select
                  id="state"
                  name="state"
                  value={filters.state}
                  onChange={handleFilterChange}
                  className="form-control"
                  placeholder="Select Project State"
                >
                  <option value="">State</option>
                  <option value="In Development">In Development</option>
                  <option value="In Testing">In Testing</option>
                  <option value="In Review">In Review</option>
                  <option value="In Production">In Production</option>

                </select>
                <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
                  {isStateOpen ? <FaChevronUp /> : <FaChevronDown />}
                </div>
              </div>
              {/* Search */}
              <input
                type="text"
                name="search"
                placeholder="Search tasks..."
                value={filters.search}
                onChange={handleFilterChange}
                className="w-full rounded-lg border border-gray-300 px-4 py-2.5 text-sm placeholder-gray-400 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200"
              />
              {/* <div className="relative w-full">
                <select
                  id="state"
                  name="state"
                  value={filters.state}
                  onChange={handleFilterChange}
                  className="form-control"
                  placeholder="Select Project State"
                >
                  <option value="">Select</option>
                  <option value="In Development">In Development</option>
                  <option value="In Testing">In Testing</option>
                  <option value="In Review">In Review</option>
                  <option value="In Production">In Production</option>

                </select>
                <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
                  {isStateOpen ? <FaChevronUp /> : <FaChevronDown />}
                </div>
              </div> */}

            </div>
            {showModal && (
              <>
                <div
                  className="selected-task-overlay"
                  onClick={() => setShowModal(false)}
                />

                <div className="selected-task-modal">
                  <div className="selected-task-header flex items-center justify-between gap-4 flex-wrap">

                    {/* Left - Title */}
                    <div className="flex-shrink-0">
                      <h4 className="text-lg font-semibold">
                        Selected Tasks ({selectedTasks.length})
                      </h4>
                    </div>

                    {/* Actions */}
                    <div className="relative">
                      <label className="block mb-1">Actions:</label>

                      <select
                        value={moveAction}
                        onChange={handleSelectedMoveChange}
                        className="form-control"
                      >
                        <option value="">Select Action</option>
                        <option value="move_to_sprint">Move to sprint</option>
                        <option value="move_to_status">Move to status</option>
                      </select>
                    </div>


                    {/* =========================
      MILESTONE
      Only for Move to Sprint
  ========================= */}
                    {moveAction === "move_to_sprint" && (
                      <> <div className="relative flex-1 max-w-md min-w-[280px]">

                        <label className="block mb-1">
                          Status <span className="text-danger">*</span>
                        </label>

                        <select
                          name="task_status"
                          value={moveStatus}
                          onChange={handleHeaderStatusChange}
                          className="form-control"
                          required={moveAction === "move_to_status"}
                        >
                          <option value="">Select Status</option>

                          {statusOptions
                            .filter((option) => option.value !== "All")
                            .map((option) => (
                              <option
                                key={option.value}
                                value={option.value}
                              >
                                {option.label}
                              </option>
                            ))}
                        </select>
                      </div>

                        <div className="relative flex-1 max-w-md min-w-[280px]">

                          <label className="block mb-1">
                            Milestone <span className="text-danger">*</span>
                          </label>

                          <select
                            name="milestone_id"
                            value={milestoneId}
                            onChange={handleChange}
                            className="form-control"
                            required={moveAction === "move_to_sprint"}
                          >
                            <option value="">Select Milestone</option>

                            {milestones.map((milestone) => (
                              <option key={milestone.id} value={milestone.id}>
                                {milestone.name}{" "}
                                {customDateFormatShort(milestone.due_date)} to{" "}
                                {customDateFormatShort(milestone.completion_date)}
                                {milestone.status === "In Progress" && " - Current"}
                              </option>
                            ))}
                          </select>
                        </div>

                      </>
                    )}


                    {/* =========================
      STATUS
      Only for Move to Status
  ========================= */}
                    {moveAction === "move_to_status" && (
                      <div className="relative flex-1 max-w-md min-w-[280px]">

                        <label className="block mb-1">
                          Status <span className="text-danger">*</span>
                        </label>

                        <select
                          name="task_status"
                          value={moveStatus}
                          onChange={handleHeaderStatusChange}
                          className="form-control"
                          required={moveAction === "move_to_status"}
                        >
                          <option value="">Select Status</option>

                          {statusOptions
                            .filter((option) => option.value !== "All")
                            .map((option) => (
                              <option
                                key={option.value}
                                value={option.value}
                              >
                                {option.label}
                              </option>
                            ))}
                        </select>
                      </div>
                    )}


                    {/* Close */}
                    <div>
                      <button
                        type="button"
                        className="btn-close flex-shrink-0"
                        onClick={() => setShowModal(false)}
                      >
                        <FiX />
                      </button>
                    </div>

                  </div>

                  <div className="selected-task-body">

                    <div className="table-responsive">
                      <table className="table table-bordered table-hover align-middle">
                        <thead className="table-light">
                          <tr>
                            <th>Task Code</th>
                            <th>Title</th>
                            <th>Status</th>
                            <th>Estimated Hours</th>
                            <th>Completed Hours</th>
                          </tr>
                        </thead>

                        <tbody>
                          {selectedTasks.map((task, index) => (
                            <tr key={task.id}>

                              {/* Task Code */}
                              <td>
                                {task.task_code}
                              </td>

                              {/* Title */}
                              <td>
                                {task.title}
                              </td>

                              {/* Status */}
                              <td>
                                <select
                                  className="form-control"
                                  value={task.task_status || ""}
                                  onChange={(e) =>
                                    handleTaskStatusChange(
                                      index,
                                      e.target.value
                                    )
                                  }

                                >
                                  <option value="">
                                    Select Status
                                  </option>

                                  {statusOptions
                                    .filter(
                                      (option) => option.value !== "All"
                                    )
                                    .map((option) => (
                                      <option
                                        key={option.value}
                                        value={option.value}
                                      >
                                        {option.label}
                                      </option>
                                    ))}
                                </select>
                              </td>

                              {/* Estimated Hours */}
                              <td>
                                <input
                                  type="number"
                                  min="0"
                                  className="form-control"
                                  placeholder="Estimated"
                                  value={
                                    formData[index]?.estimated_hours ?? ""
                                  }
                                  onChange={(e) =>
                                    handleTaskInputChange(
                                      index,
                                      "estimated_hours",
                                      e.target.value
                                    )
                                  }
                                />
                              </td>

                              {/* Completed Hours */}
                              <td>
                                <input
                                  type="number"
                                  min="0"
                                  className="form-control"
                                  placeholder="Completed"
                                  value={
                                    formData[index]?.completed_hours ?? ""
                                  }
                                  onChange={(e) =>
                                    handleTaskInputChange(
                                      index,
                                      "completed_hours",
                                      e.target.value
                                    )
                                  }
                                />
                              </td>

                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <div className="selected-task-footer">
                      <button
                        className="btn btn-secondary"
                        onClick={() => setShowModal(false)}
                      >
                        Cancel
                      </button>

                      <button
                        className="btn btn-primary"
                        onClick={handleSubmitSelectedTasks}
                      >
                        Submit
                      </button>
                    </div>

                  </div>


                </div>
              </>
            )}

            <div className="task-list">
              {!tasks || tasks.length === 0 ? (
                <div className="no-tasks">
                  <p>No tasks found</p>
                  <Link to="/app/tasks/new" className="btn btn-primary">Create your first task</Link>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>
                          <input
                            type="checkbox"
                            checked={
                              tasks.length > 0 &&
                              selectedTasks.length === tasks.length
                            }
                            onChange={(e) => handleSelectAll(e.target.checked)}
                          />
                        </th>
                        <th>Code</th>
                        <th>Title</th>
                        <th>Type</th>
                        <th>Priority</th>
                        {/* <th>Project</th> */}
                        {/* <th>Milestone</th> */}
                        <th>Parent Task</th>
                        <th>Assignee</th>
                        <th>Hours</th>
                        <th>Status</th>
                        <th style={{ 'width': '40px' }}>State</th>
                        <th>Due Date</th>
                        <th>Created By</th>
                        <th>Updated At</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tasks.map(task => (
                        <tr key={task.id}>
                          <td>
                            <input
                              type="checkbox"
                              checked={selectedTasks.some((item) => item.id === task.id)}
                              onChange={(e) => handleSelectTask(task, e.target.checked)}
                            />
                          </td>

                          <td>
                            <span
                              className="cursor-pointer text-info inline-flex items-start"
                              onClick={() => handleTaskClick(task.id, false)}
                            >
                              {task.task_code}

                              {task.comments?.length > 0 && (
                                <sup className="ml-1 text-orange-500">
                                  <FaRegCommentDots size={10} />
                                </sup>
                              )}
                            </span>
                          </td>
                          <td>
                            <span
                              className="task-info cursor-pointer"
                              onClick={() => handleTaskClick(task.id, false)}
                            >
                              {task.title}
                            </span>
                          </td>

                          <td>
                            <span className="badge badge-secondary">
                              {task.task_type || 'Task'}
                            </span>
                          </td>
                          <td>
                            <span className={`badge ${getPriorityBadge(task.priority)}`}>
                              {task.priority}
                            </span>
                          </td>
                          {/* <td>
                      {task.project ? (
                        <Link to={`/app/projects/${task.project.id}`}>
                          {task.project.name}
                        </Link>
                      ) : (
                        <span className="text-muted">-</span>
                      )}
                    </td> */}
                          {/* <td>
                            {task.milestone ? (
                              <span className="text-info">
                                {task.milestone.name || task.milestone_id}
                              </span>
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </td> */}
                          <td>
                            {task.parent_task ? (
                              <Link to={`/app/tasks/${task.parent_task.id}`} className="text-primary">
                                {task.parent_task.title || task.parent_task_id}
                              </Link>
                            ) : task.parent_task_id ? (
                              <span className="text-muted">{task.parent_task_id}</span>
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </td>
                          <td>
                            {task.assignee ? (
                              <span>
                                {task.assignee.first_name} {task.assignee.last_name}
                              </span>
                            ) : (
                              <span className="text-muted">Unassigned</span>
                            )}
                          </td>
                          <td>

                            <span>
                              {(task.actual_hours != null && task.actual_hours != '0.00') ? task.actual_hours : 0} / {(task.estimated_hours != null && task.estimated_hours != '0.00') ? task.estimated_hours : 0}
                            </span>

                          </td>
                          <td>
                            <span className={`badge ${getStatusBadge(task.status)}`}>
                              {task.status}
                            </span>
                          </td>

                          <td
                            onMouseEnter={() => setHoveredTaskId(task.id)}
                            onMouseLeave={() => setHoveredTaskId(null)}
                            style={{ 'width': '40px' }}
                          >
                            {hoveredTaskId === task.id ? (
                              <select
                                value={taskStatuses[task.id] ?? task.status}
                                className="form-control"
                                onChange={(e) =>
                                  handleStateChange(task, e.target.value)
                                }
                              >
                                <option value="In Development">In Development</option>
                                <option value="In Testing">In Testing</option>
                                <option value="In Review">In Review</option>
                                <option value="In Production">In Production</option>
                              </select>
                            ) : (
                              <span className={`badge ${getStatusBadge(
                                taskStatuses[task.id] ?? task.state
                              )}`}>
                                {taskStatuses[task.id] ?? task.state}
                              </span>
                            )}
                          </td>

                          <td>
                            {task.due_date ? (
                              customDateFormatShort(task.due_date)
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </td>
                          <td>
                            {task.reporter ? (
                              <span>
                                {task.reporter.first_name} {task.reporter.last_name}
                              </span>
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </td>
                          <td title={formatTime(task?.createdAt)}>
                            {task.updatedAt ? (
                              formatTime(task.updatedAt)
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </td>
                          <td>
                            <div className="action-buttons">
                              {/* <Link
                          to={`/app/tasks/${task.id}/edit`}
                          className="btn btn-sm btn-outline-primary custom-pbtn"
                          title="Edit"
                        >
                          <i className="fas fa-edit"></i>
                        </Link> */}
                              <button
                                onClick={() => handleTaskEdit(task.id)}
                                className="btn btn-sm btn-outline-primary custom-pbtn"
                                title="Edit"
                              >
                                <i className="fas fa-edit custom-fas-icon"></i>
                              </button>

                              <button
                                onClick={() => handleTaskCopy(task)}
                                className="btn btn-sm badge-info"
                                title="Copy"
                              >
                                <i className="fas fa-copy"></i>
                              </button>
                              {/* 
                        <button
                          onClick={() => handleTaskDownload(task)}
                          className="btn btn-sm btn-secondary "
                          title="Download"
                        >
                          <i className="fas fa-download"></i>
                        </button> */}

                              {/* <button
                          onClick={() => {
                            setSelectedTask(task);
                            setShowDeleteModal(true);
                          }}
                          className="btn btn-sm btn-outline-danger custom-dbtn"
                          title="Delete"
                        >
                          <i className="fas fa-trash"></i>
                        </button> */}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>


              )}
            </div>

            {pagination.pages > 1 && (
              <div className="pagination">
                <button
                  onClick={() => setFilters(prev => ({ ...prev, page: prev.page - 1 }))}
                  disabled={filters.page === 1}
                  className="btn btn-outline-primary"
                >
                  Previous
                </button>
                <span className="page-info">
                  Page {pagination.page} of {pagination.pages}
                </span>
                <button
                  onClick={() => setFilters(prev => ({ ...prev, page: prev.page + 1 }))}
                  disabled={filters.page === pagination.pages}
                  className="btn btn-outline-primary"
                >
                  Next
                </button>
              </div>
            )}
          </div>
        </div>
        <div className='w-2/5' style={{ marginTop: '1.3%' }}>

          <div className="bg-white shadow-lg border border-gray-200 overflow-hidden">

            {/* Card Header */}
            <div className="px-5 py-4 border-b">
              <div>
                <div>
                  <div
                    className="relative"
                    ref={dropdownRef}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <button
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setShowAssignees((prev) => !prev);
                      }}
                      className="flex w-full items-center justify-between rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm hover:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-200"
                    >
                      <span className="truncate">
                        {getAssigneeDisplay()}
                      </span>

                      {showAssignees ? <FaChevronUp /> : <FaChevronDown />}
                    </button>

                    {showAssignees && (
                      <div
                        className="absolute left-0 right-0 z-50 mt-2 max-h-64 overflow-y-auto rounded-lg border border-gray-200 bg-white shadow-lg"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {/* All Assignees */}
                        <label className="flex cursor-pointer items-center gap-3 px-4 py-2 hover:bg-gray-100">
                          <input
                            type="checkbox"
                            checked={
                              users.length > 0 &&
                              filters.assigned_to.length === users.length
                            }
                            onClick={(e) => e.stopPropagation()}
                            onChange={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleAllAssignees();
                            }}
                          />
                          <span>All Assignees</span>
                        </label>

                        {/* Unassigned */}
                        <label className="flex cursor-pointer items-center gap-3 px-4 py-2 hover:bg-gray-100">
                          <input
                            type="checkbox"
                            checked={filters.assigned_to.includes("unassigned")}
                            onClick={(e) => e.stopPropagation()}
                            onChange={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleAssigneeChange("unassigned");
                            }}
                          />
                          <span>Unassigned</span>
                        </label>

                        <hr />

                        {/* Users */}
                        {users.map((user) => (
                          <label
                            key={user.id}
                            className="flex cursor-pointer items-center gap-3 px-4 py-2 hover:bg-gray-100"
                          >
                            <input
                              type="checkbox"
                              checked={filters.assigned_to.includes(user.id)}
                              onClick={(e) => e.stopPropagation()}
                              onChange={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleAssigneeChange(user.id);
                              }}
                            />
                            <span>
                              {user.first_name} {user.last_name}
                            </span>
                          </label>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Card Body */}
            <div className="max-h-[90%] min-h-[15.625rem] overflow-y-auto p-4 space-y-3">

              {resources.map((resource) => {
                const taskStatusData = {
                  labels: resource.tasks_status.map((item) => item.status),
                  datasets: [
                    {
                      data: resource.tasks_status.map((item) => item.count),
                      backgroundColor: resource.tasks_status.map((item) => item.color),
                      borderWidth: 0,
                      hoverBorderWidth: 0,
                    },
                  ],
                };

                const plannedHours = Number(resource.planned_working_hours || 0);
                const estimatedHours = Number(resource.tasks_estimated_hours || 0);

                const plannedHoursData = {
                  labels: ["Planned Hours", "Deficit Hours"],
                  datasets: [
                    {
                      data: [
                        Math.min(estimatedHours, plannedHours),
                        Math.max(plannedHours - estimatedHours, 0),
                      ],
                      backgroundColor: ["#6366f1", "#ff02ff"],
                      borderWidth: 0,
                      hoverBorderWidth: 0,
                    },
                  ],
                };

                return (
                  <div
                    key={resource.id}
                    className="flex items-center justify-between rounded-xl border border-gray-100 bg-gray-50 p-3 hover:bg-white hover:shadow-md transition"
                  >
                    {/* Left */}
                    <div className="flex items-center gap-3">
                      {/* Nested Doughnuts */}
                      <div className="relative w-15 h-15">
                        {/* Outer Doughnut - Planned Working Hours */}
                        <div className="inset-0 w-20 h-20">
                          <Doughnut
                            data={plannedHoursData}
                            options={{
                              responsive: true,
                              maintainAspectRatio: false,
                              cutout: "65%",
                              plugins: {
                                legend: {
                                  display: false,
                                },
                                tooltip: {
                                  enabled: false,
                                  external: externalTooltipHandler,
                                  callbacks: {
                                    label: (context) => {
                                      const value = context.raw;
                                      return `${context.label}: ${value} hrs`;
                                    },
                                  },
                                },
                              },
                            }}
                          />
                        </div>

                        {/* Inner Doughnut - Task Status */}
                        <div className="absolute inset-2">
                          <Doughnut
                            data={taskStatusData}
                            options={{
                              responsive: true,
                              maintainAspectRatio: false,
                              cutout: "75%",
                              plugins: {
                                legend: {
                                  display: false,
                                },
                              },
                              tooltip: {
                                enabled: false,
                                external: externalTooltipHandler,
                                callbacks: {
                                  label: (context) => {
                                    const value = context.raw;
                                    return `${context.label}: ${value} hrs`;
                                  },
                                },
                              },
                            }}
                          />
                        </div>

                        {/* Center */}
                        {/* <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                          <span className="text-[9px] font-bold text-gray-700">
                            {estimatedHours}h
                          </span>
                        </div> */}
                      </div>

                      <div>
                        <h4 className="text-sm font-semibold text-gray-800">
                          {resource.name}
                        </h4>

                        <p className="text-xs text-gray-500">
                          {resource.role}
                        </p>
                      </div>
                    </div>

                    {/* Right */}
                    <div className="text-right">
                      <div className="text-sm font-semibold text-green-600">
                        {resource.actual_hours}/{resource.estimated_hours}
                      </div>

                      {/* <div className="text-[10px] text-gray-500">
                        {estimatedHours} / {plannedHours} hrs
                      </div> */}
                    </div>
                  </div>
                );
              })}

            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default TaskList;


